module.exports = __webpack_public_path__ + "img/logo-bg-black.8b30757a.svg";